import React from 'react';
import PropTypes from 'prop-types';

const progress = props => (
  <div className="progress-bar">
    <div className={['progress-text', (props.step === 'activity') && 'active'].join(' ')}>Step 1 of 4</div>
    <div className={['progress-text', (props.step === 'loseWeight') && 'active'].join(' ')}>Step 2 of 4</div>
    <div className={['progress-text', (props.step === 'smoking') && 'active'].join(' ')}>Step 3 of 4</div>
    <div className={['progress-text', (props.step === 'alcohol') && 'active'].join(' ')}>Step 4 of 4</div>
  </div>
);

progress.propTypes = {
  step: PropTypes.oneOf(['activity', 'loseWeight', 'smoking', 'alcohol', 'all']).isRequired,
};

export default progress;



// WEBPACK FOOTER //
// ./src/Components/Progress/index.jsx